<template>

    <div>

        <transition name="modal">
            <v-modal-subscription-delete v-if="showModal === 'subscription-delete'" :subscription="subscription" @changed="$emit('changed')" />
        </transition>

        <v-page-section padded>
            <template #title>Current Plan</template>
            <template #body>
                <v-list>
                    <v-list-item>
                        <div>
                            <span>{{ subscription.amount / 100 | currency }} / {{ subscription.interval }} • {{ subscription.quantity | numeral('0,0') }} customers</span><br>
                            <span v-if="subscription.discount" class="small text-muted">Promo: {{ subscription.discount.coupon.name }}</span>
                        </div>
                        <div>
                            <v-button v-if="!subscription.cancel_at_period_end" class="float-right" size="sm" btn-style="danger" @click.native="$store.commit('showModal', 'subscription-delete')">Unsubscribe</v-button>
                            <v-button v-else class="float-right" size="sm" btn-style="danger" @click.native="$store.commit('showModal', 'subscription-delete')">ends {{ subscription.current_period_end | date }}</v-button>
                        </div>
                    </v-list-item>
                </v-list>
            </template>
        </v-page-section>

    </div>

</template>

<script>

import ModalSubscriptionDelete from '@modals/subscription/ModalSubscriptionDelete';

export default {

    components: {
        'v-modal-subscription-delete': ModalSubscriptionDelete,
    },

    props: {
        subscription: {
            type: Object,
        },
    },

}

</script>